import { gql } from "@apollo/client";

export const MY_HR_CREATE_NEW_PASSWORD = gql`
  mutation createNewPassword($email: String!, $password: String!) {
    createNewPassword(email: $email, password: $password) {
      status
      statusMessage
    }
  }
`;
